//优惠券详情
Vue.component(
    'coupon-detail-alert',
    resolve => require(["../../components/adfree/coupon_detail"], resolve)
);

//暑期活动弹窗
Vue.component(
    'speed-activity-alert',
    resolve => require(["../../components/themeActivity/speedActivityAlert"], resolve)
);

//滁州联通弹窗
Vue.component(
    'chu-zhou-pop',
    resolve => require(["../../components/chuZhou/chuZhouPop"], resolve)
);

//无锡新改版活动弹窗
Vue.component(
    'wu-xi-pop',
    resolve => require(["../../components/wuXi/wuXiPop"], resolve)
);

//主题活动页面
Vue.component(
    'theme-activity',
    resolve => require(["../../components/themeActivity"], resolve)
);

//小程序测速pk提现活动的弹窗
Vue.component(
    'wechat-pk-activity-alert',
    resolve => require(["../../components/weChatPkActivity/alert"], resolve)
);

//通用优惠券弹窗
Vue.component(
    'cate2-pop',
    resolve => require(["../../components/cateImagePop/Cate2Pop"], resolve)
);


//通用优惠券弹窗
Vue.component(
    'isp-satisfaction-pop',
    resolve => require(["../../components/ispSatisfaction/index"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/coupon.js